<template>
  <van-swipe ref="slider" :autoplay="autoPlay" dir="ltr" indicator-color="black" @change="onChange">
    <van-swipe-item v-for="(image, index) in combineImages" :key="`gallery-image-${index}`"
                    @click="index ? openGallery(index) : null">
      <niceone-image :src="image" class="w-full" prefetch></niceone-image>

      <!-- Gallery Thumbnails placeholders -->
      <gallery-placeholder v-if="!index && !!beforeAfterImage"
                           :icon-src="$publicPath('/images/comparisonOverlayIcon.svg')"
                           :text="$t('rewards.compare_tap_description')" @click="openComparePopup"/>
      <!-- three sixty placeholder -->
      <gallery-placeholder v-if="!index && !!threeSixtyImages.length" :icon-src="$publicPath('/images/360degree.svg')"
                           :text="$t('rewards.three_sixty_tap_view')" @click="openThreeSixtyPopup"/>
    </van-swipe-item>
    <van-swipe-item v-if="data?.video_url" key="gallery-image-video" :style="{height: videoHeight}"
                    class="flex-center bg-light-grey">
      <div :class="[isVideoActive ? 'pointer-events-none' : 'pointer-events-auto']" class="absolute inset-0 z-10"
           @click="stopVideo"></div>
      <Video :videoUrl="data?.video_url"/>
    </van-swipe-item>
  </van-swipe>
  <van-image-preview v-model:show="showGallery" :images="images" :showIndex="false" :startPosition="startPosition"
                     closeable dir="ltr" showIndicators>
  </van-image-preview>
</template>

<script setup>
import Video from "@/components/product/Video";
import GalleryPlaceholder from "@/components/product/GalleryPlaceholder";

import {EVENTS} from "@/constants/events";

const props = defineProps({
  images: {
    type: Array,
    default: () => [],
  },
  data: {
    type: Object,
    default: {}
  },
});

const slider = ref(null);
const autoPlay = ref(3000)
const showGallery = ref(false);
const startPosition = ref(0);

// get three sixty images for the product
const threeSixtyImages = computed(() => props?.data?.images360)

// before and after for image compare
const beforeAfterImage = computed(() => !!props?.data?.images_after_before ? props?.data?.images_after_before[0] : false)

const combineImages = computed(() => {
  let extraImages = threeSixtyImages.value[0] || beforeAfterImage.value?.before
  return props?.images?.length ? [extraImages, ...props?.images].filter(Boolean) : [];
});

const openGallery = (index) => {
  startPosition.value = index;
  showGallery.value = true;
};

const videoHeight = ref(null);
onMounted(() => videoHeight.value = `${slider.value?.state?.rect.width}px`);

const isVideoActive = ref(false);
const {on: onOpenVideo} = useEventBus(EVENTS.PDP_VIDEO);
const imagesLength = ref(props?.images?.length)

onOpenVideo(() => {
  isVideoActive.value = !isVideoActive.value;
  isVideoActive.value && slider.value?.state?.active < imagesLength.value ? swapSwiperIndex() : resetSwiper();
});

const swapSwiperIndex = () => {
  slider.value.swipeTo(imagesLength.value);
  autoPlay.value = false
};

const resetSwiper = () => {
  slider.value?.swipeTo(0);
  isVideoActive.value = false
  resetAutoPlay()
};

const resetAutoPlay = () => autoPlay.value = 3000

const stopVideo = () => {
  autoPlay.value = false
  isVideoActive.value = true
};

const onChange = (slide) => {
  if (imagesLength.value !== slide) {
    isVideoActive.value = false
    resetAutoPlay();
  }
}

const {emit: openComparePopup} = useEventBus(EVENTS.COMPARE_POPUP);
const {emit: openThreeSixtyPopup} = useEventBus(EVENTS.THREE_SIXTY_POPUP);
</script>